import axios from "axios";
import { serviceUrl } from "../../config";

const BACKEND_URL = serviceUrl;

export const profileChangePassword = async (
    username,
    newpassword,
    PIN,
    userid,
    currpassword
  ) => {
    try {
      const data = JSON.stringify({
        svc: "forgot_password",
        pid: "changeUserPassword",
        dat: {
          userid: userid,
          PIN: PIN,
          username: username,
          newpassword: newpassword,
          currpassword: currpassword
        },
      });
  
      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  export const profileChangePIN = async (
    username,
    newpin,
    oldpin,
    userid
  ) => {
    try {
      const data = JSON.stringify({
        svc: "forgot_password",
        pid: "setuserpin",
        dat: {
          userid: userid,
          oldpin: oldpin,
          username: username,
          newpin: newpin
        },
      });
  
      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  export const sendEmailPIN = async (
    // role,
    email,
    username,
    userid,
    franchiseeid,
    telephoneno,
    countryid,
    isOperator
  ) => {
    try {
      const data = JSON.stringify({
        svc: "forgot_password",
        pid: "settemppin",
        dat: {
          userid: userid,
          username: username,
          // role: role,
          email: email,
          franchiseeid: franchiseeid,
          telephoneno: telephoneno,
          countryid: countryid,
          isOperator: isOperator
        },
      });
  
      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  export const SendNewPINSMS = async (
    telephoneno,
    userID,
    langID,
    countryid,
    franchiseeID
  ) => {
    try {
      const data = JSON.stringify({
        svc: "forgot_password",
        pid: "SendNewPINSMS",
        dat: {
          telephoneno: telephoneno,
          userID: userID,
          langID: langID,
          countryid: countryid,
          franchiseeID: franchiseeID
        },
      });
  
      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  export const ConsumerResetPIN = async (
    consumeremail,
    consumeruserid,
    consumerlanguage,
    consumercountry,
    consumerfranchiseid
  ) => {
    try {
      const data = JSON.stringify({
        svc: "forgot_password",
        pid: "SendNewPINSMSFranchisee",
        dat: {
          consumeremail: consumeremail,
          consumeruserid: consumeruserid,
          consumerlanguage: consumerlanguage,
          consumercountry: consumercountry,
          consumerfranchiseid: consumerfranchiseid
        },
      });
  
      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }

  export const SetUserPINWithoutOldPIN = async (
    location,
    username,
    userid,
    userData,
    pin
  ) => {
    try {
      const data = JSON.stringify({
        svc: "forgot_password",
        pid: "SetUserPINWithoutOldPIN",
        dat: {
          location: location,
          username: username,
          userid: userid,
          userData: userData,
          pin: pin
        },
      });
  
      console.log(data);
  
      const config = {
        method: "post",
        url: BACKEND_URL,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
  
      const response = await axios(config);
      console.log(response);
  
      return response.data;
    } catch (error) {
      console.log(error);
    }
  }